import { SupportedCollaterals } from "@astrid-dao/lib-base";

import wastrBlackLogo from "./assets/images/currencies/astr-black.svg";
import wastrLogo from "./assets/images/currencies/astr.svg";
import astarLogo from "./assets/images/currencies/astr.svg";
import atidLightLogo from "./assets/images/currencies/atid-light.svg";
import atidLogo from "./assets/images/currencies/atid.svg";
import baiLightLogo from "./assets/images/currencies/bai-light.svg";
import baiLogo from "./assets/images/currencies/bai.svg";
// import bnbLogo from "./assets/images/currencies/bnb.webp";
import busdLogo from "./assets/images/currencies/busd.svg";
import ceUsdcLogo from "./assets/images/currencies/ce-usdc.svg";
import ceUsdtLogo from "./assets/images/currencies/ce-usdt.svg";
import daiLogo from "./assets/images/currencies/dai.svg";
import dotLogo from "./assets/images/currencies/dot.svg";
import wbtcLogo from "./assets/images/currencies/wbtc.svg";
import wethLightLogo from "./assets/images/currencies/weth-light.svg";
import wethLogo from "./assets/images/currencies/weth.svg";
import xcBaiLogo from "./assets/images/currencies/xc-bai.svg";

type AstridDaoTokens =
  | "ATID"
  | "ATID_LIGHT"
  | "BAI"
  | "BAI_LIGHT"
  | "ASTR"
  | "WASTR_DARK"
  | "WSBY"
  | "xcBAI"
  | "WDEV";
export type CurrencyIcons = SupportedCollaterals | AstridDaoTokens;

export function getCurrencyIcon(currency: CurrencyIcons, theme = "light"): string {
  // return currency icon from iconCurrencyMap or iconCurrencyLightMap base on theme
  return theme === "light" ? iconCurrencyLightMap[currency] : iconCurrencyMap[currency];
}

export const iconCurrencyMap: Record<CurrencyIcons, string> = {
  DEV: astarLogo,
  SBY: astarLogo,
  ATID: atidLogo,
  ATID_LIGHT: atidLightLogo,
  BAI: baiLightLogo,
  BAI_LIGHT: baiLightLogo,
  ceUSDC: ceUsdcLogo,
  ceUSDT: ceUsdtLogo,
  ASTR: astarLogo,
  WASTR: wastrLogo,
  // WBNB: bnbLogo,
  WBTC: wbtcLogo,
  WETH: wethLogo,
  BUSD: busdLogo,
  DAI: daiLogo,
  WSBY: wastrLogo,
  WDEV: wastrLogo,
  DOT: dotLogo,
  // KSM: ksmLogo,
  WASTR_DARK: wastrBlackLogo,
  xcBAI: xcBaiLogo
};

export const iconCurrencyLightMap: Record<CurrencyIcons, string> = {
  DEV: astarLogo,
  SBY: astarLogo,
  ATID: atidLogo,
  ATID_LIGHT: atidLightLogo,
  BAI: baiLightLogo,
  BAI_LIGHT: baiLightLogo,
  ceUSDC: ceUsdcLogo,
  ceUSDT: ceUsdtLogo,
  ASTR: astarLogo,
  WASTR: wastrLogo,
  // WBNB: bnbLogo,
  WBTC: wbtcLogo,
  WETH: wethLogo,
  BUSD: busdLogo,
  DAI: daiLogo,
  WSBY: wastrLogo,
  WDEV: wastrLogo,
  DOT: dotLogo,
  // KSM: ksmLogo,
  WASTR_DARK: wastrBlackLogo,
  xcBAI: xcBaiLogo
};
